import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "material-view" }
const _hoisted_2 = { class: "material-view" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "top" }, null, -1)
const _hoisted_4 = { class: "material-view-col" }
const _hoisted_5 = {
  key: 0,
  class: "partner-material-badge"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "flex-container-row gap10" }
const _hoisted_9 = { class: "flex-container-row gap10 flex-wrap" }
const _hoisted_10 = { style: {"margin-left":"auto"} }
const _hoisted_11 = { class: "material-view-col" }
const _hoisted_12 = {
  key: 0,
  class: "history-items-col"
}
const _hoisted_13 = { class: "history-item-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_material_picture = _resolveComponent("material-picture")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_stock_indicator = _resolveComponent("stock-indicator")!
  const _component_purchase_button = _resolveComponent("purchase-button")!
  const _component_doc_link = _resolveComponent("doc-link")!
  const _component_material_link_section = _resolveComponent("material-link-section")!
  const _component_material_link = _resolveComponent("material-link")!
  const _component_loader_guard = _resolveComponent("loader-guard")!
  const _component_portal_page = _resolveComponent("portal-page")!

  return (_openBlock(), _createBlock(_component_portal_page, {
    title: _ctx.pageTitle,
    "show-log-off": true,
    "show-back-button": true
  }, {
    navigation: _withCtx(() => [
      _createElementVNode("a", {
        href: "#",
        class: "dark-header-link",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goAllBack && _ctx.goAllBack(...args)), ["prevent"]))
      }, [
        _createVNode(_component_my_icon, {
          icon: "grid",
          size: 18
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.localize('ReturnToOverview')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_loader_guard, { "has-loaded": _ctx.hasLoaded }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_icon, {
                          icon: "file",
                          size: 20
                        }),
                        _createVNode(_component_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('Description')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card_body, null, {
                      default: _withCtx(() => [
                        (_ctx.materialData?.partnerMaterialNo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.localize('ownMaterialNo')) + ": " + _toDisplayString(_ctx.materialData.partnerMaterialNo), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("h1", null, _toDisplayString(_ctx.materialText( _ctx.materialData )), 1),
                        (_ctx.salesText)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              innerHTML: _ctx.salesText
                            }, null, 8, _hoisted_6))
                          : _createCommentVNode("", true),
                        (_ctx.qtyOnEquipment != null)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.localize('qtyForDevice')) + ": " + _toDisplayString(_ctx.qtyOnEquipment), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_material_picture, {
                          "material-data": _ctx.materialData,
                          "max-height": 300
                        }, null, 8, ["material-data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.showOrderingSection)
                  ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_my_icon, {
                              icon: "cart",
                              size: 20
                            }),
                            _createVNode(_component_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('ordering')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card_body, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                (_ctx.showPrice)
                                  ? (_openBlock(), _createBlock(_component_card, {
                                      key: 0,
                                      class: "label"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_card_header, { class: "label" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_card_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.localize('Price')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_card_body, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.priceData), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.isAdmin)
                                  ? (_openBlock(), _createBlock(_component_card, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_card_header, { class: "label" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_card_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.localize('Inventory')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_card_body, { class: "text-right" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.numberFormatter(_ctx.materialData.availableStock)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_card, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_card_header, { class: "label" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.localize('Status')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_card_body, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_stock_indicator, { "material-item": _ctx.materialData }, null, 8, ["material-item"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_purchase_button, {
                                  "material-number": _ctx.materialData.materialNo
                                }, null, 8, ["material-number"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.additionalDocsForEveryone?.length)
                  ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_header, { class: "k-hstack subsection accent-documents" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_my_icon, {
                              icon: "attachment",
                              size: 20
                            }),
                            _createVNode(_component_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('documents')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card_body, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalDocsForEveryone, (doc) => {
                              return (_openBlock(), _createBlock(_component_doc_link, {
                                key: doc.blobName,
                                doc: doc,
                                style: {"margin-left":"10px"}
                              }, null, 8, ["doc"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.additionalDocsForAdmins?.length)
                  ? (_openBlock(), _createBlock(_component_card, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_header, { class: "k-hstack subsection accent-documents" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_my_icon, {
                              icon: "attachment",
                              size: 20
                            }),
                            _createVNode(_component_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('documentsForAdminsSectionTitle')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card_body, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalDocsForAdmins, (doc) => {
                              return (_openBlock(), _createBlock(_component_doc_link, {
                                key: doc.blobName,
                                doc: doc,
                                style: {"margin-left":"10px"}
                              }, null, 8, ["doc"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.materialData.hasReplacement)
                  ? (_openBlock(), _createBlock(_component_material_link_section, {
                      key: 2,
                      title: _ctx.localize('replacement'),
                      avatar: "replacement",
                      materials: _ctx.materialData.replacementItems,
                      comment: _ctx.localize('OrderAllReplacements')
                    }, null, 8, ["title", "materials", "comment"]))
                  : _createCommentVNode("", true),
                (_ctx.materialData.hasBoughtWithBom)
                  ? (_openBlock(), _createBlock(_component_material_link_section, {
                      key: 3,
                      title: _ctx.localizeBomItemText('BOMitems_Recommended'),
                      avatar: "recommended",
                      materials: _ctx.materialData.recommendedItems
                    }, null, 8, ["title", "materials"]))
                  : _createCommentVNode("", true),
                (_ctx.materialData.relatedItems?.length)
                  ? (_openBlock(), _createBlock(_component_material_link_section, {
                      key: 4,
                      title: _ctx.localizeBomItemText('BOMitems_Related'),
                      avatar: "maintenance",
                      materials: _ctx.effectiveRelatedItems
                    }, null, 8, ["title", "materials"]))
                  : _createCommentVNode("", true),
                (_ctx.materialData.hasAlternativeItemsBom)
                  ? (_openBlock(), _createBlock(_component_material_link_section, {
                      key: 5,
                      title: _ctx.localizeBomItemText('BOMitems_Alternatives'),
                      avatar: "alternative",
                      materials: _ctx.materialData.alternativeItems
                    }, null, 8, ["title", "materials"]))
                  : _createCommentVNode("", true),
                (_ctx.parentMaterials.length)
                  ? (_openBlock(), _createBlock(_component_material_link_section, {
                      key: 6,
                      title: _ctx.localize('BOMitems_WhereUsed'),
                      avatar: "where-used",
                      materials: _ctx.parentMaterials,
                      "show-material-count": false
                    }, null, 8, ["title", "materials"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.materialHistoryItems?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_my_icon, { icon: "eye" }),
                              _createTextVNode(" " + _toDisplayString(_ctx.localize('RecentlyViewed')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialHistoryItems, (item) => {
                              return (_openBlock(), _createBlock(_component_material_link, {
                                key: item.materialNumber,
                                "material-data": item,
                                size: 140,
                                onClick: ($event: any) => (_ctx.onClick(item))
                              }, null, 8, ["material-data", "onClick"]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["has-loaded"])
    ]),
    _: 1
  }, 8, ["title"]))
}